import { render, staticRenderFns } from "./Endcontroll.vue?vue&type=template&id=4a740f20&scoped=true&"
import script from "./Endcontroll.vue?vue&type=script&lang=ts&"
export * from "./Endcontroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a740f20",
  null
  
)

export default component.exports